import React from 'react';

export function HowToOrder() {
  return (
    <section id="order" className="section order-section">
      <div className="container">
        <h2>We're Here to Help</h2>
        <p className="section-intro">
          Have a question about your order, delivery or our products? Reach out via email anytime.
          Follow us on Instagram to stay updated on new flavours, restocks and offers.
        </p>
        <div className="order-options">
          <a
            href="mailto:kianefoods@gmail.com"
            className="order-card email-card"
          >
            <div className="order-card-icon">
              <svg viewBox="0 0 32 32" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="16" r="16" fill="var(--amber)"/>
                <path d="M8 11h16a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1z" stroke="#fff" strokeWidth="1.5" fill="none"/>
                <path d="M7.3 11.5 16 17.5l8.7-6" stroke="#fff" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3>Customer Support</h3>
            <p>Questions about delivery, ingredients or your order? Drop us an email — we're just a message away.</p>
            <span className="order-btn">Email Us</span>
          </a>

          <a
            href="https://instagram.com/kiane.yumm"
            className="order-card instagram-card"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="order-card-icon">
              <svg viewBox="0 0 32 32" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="ig-grad" x1="0%" y1="100%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#f09433"/>
                    <stop offset="25%" stopColor="#e6683c"/>
                    <stop offset="50%" stopColor="#dc2743"/>
                    <stop offset="75%" stopColor="#cc2366"/>
                    <stop offset="100%" stopColor="#bc1888"/>
                  </linearGradient>
                </defs>
                <circle cx="16" cy="16" r="16" fill="url(#ig-grad)"/>
                <rect x="9" y="9" width="14" height="14" rx="4" stroke="#fff" strokeWidth="1.5" fill="none"/>
                <circle cx="16" cy="16" r="3.5" stroke="#fff" strokeWidth="1.5" fill="none"/>
                <circle cx="21" cy="11" r="1" fill="#fff"/>
              </svg>
            </div>
            <h3>Follow on Instagram</h3>
            <p>New flavours, restocks, behind-the-scenes and exclusive offers — all on our page.</p>
            <span className="order-btn">@kiane.yumm</span>
          </a>
        </div>
      </div>
    </section>
  );
}
